var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCn = function SvgCn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DE2910",
    d: "M1.1 12C1.1 6 6 1.1 12 1.1S22.9 6 22.9 12 18 22.9 12 22.9 1.1 18 1.1 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDE00",
    d: "m7.9 6-.8-2.5L6.3 6H3.7l2.1 1.5L5 10l2.1-1.5L9.2 10l-.8-2.5L10.5 6zM12.9 3.9l.5.8v-.9l.9-.2-.8-.3.1-.9-.6.6-.8-.3.4.8-.5.6zM15.199 6.2l.1.9.4-.8.9.2-.7-.7.5-.7-.8.3-.6-.6.1.9-.8.4zM15.899 9.6l.7-.5h-.9l-.3-.8-.2.8-.9.1.8.4-.3.9.7-.5.7.4zM13.5 11.6v-.8l-.5.6-.8-.3.4.8-.5.6.8-.2.5.7.1-.8.8-.3z"
  })));
};
export default SvgCn;